import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.92805 6.00676C3.75513 5.98448 3.57958 6.01759 3.42674 6.10131C3.2739 6.18504 3.15167 6.31504 3.0777 6.47256C3.00373 6.63008 2.98184 6.80698 3.01519 6.97772C3.04853 7.14846 3.13539 7.30422 3.26323 7.42251L9.33255 12.7635C9.51957 12.92 9.75588 13.0058 10 13.0058C10.2441 13.0058 10.4804 12.92 10.6674 12.7635L16.7368 7.42251C16.8646 7.30422 16.9515 7.14846 16.9848 6.97772C17.0182 6.80698 16.9963 6.63008 16.9223 6.47256C16.8483 6.31504 16.7261 6.18504 16.5733 6.10131C16.4204 6.01759 16.2449 5.98448 16.0719 6.00676H3.92805Z",
		fill: "#0D2976"
	})
});
export default SvgCaretDown;
